<template>
  <popup
    :close-action="closeActionClicked"
    class="update-credit-card-popup"
    :title="'עדכון פרטי כרטיס'">
    <template v-slot:content>
      <personal-info-form/>
      <credit-card-details-form/>
      <div class="button-container">
        <div class="result-container" v-if="tokenizationError || updateCompletedSuccessfully">
          <div class="top">
            <div class="icon">
              <img class="icon" :src="getImageUrl()">
            </div>
            <div class="message" :class="{error: tokenizationError, success: updateCompletedSuccessfully}">
              {{ resultMessage }}
            </div>
          </div>
          <div class="cta" v-if="tokenizationError">
            אפשר לרענן את העמוד ולנסות להשתמש בכרטיס אחר.
          </div>
        </div>
        <riseup-button v-else :loading="loadingToken" title="עדכון פרטי כרטיס" :action="updateCreditCardClicked"/>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import { mapActions, mapState } from 'vuex';
import Segment from '../../../../../Segment';
import PersonalInfoForm from './components/PersonalInfoForm.vue';
import CreditCardDetailsForm from './components/CreditCardDetailsForm.vue';
import PaymeInterface from '../../../../../Payme';

export default {
  name: 'UpdateCreditCardPopup',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    PersonalInfoForm,
    CreditCardDetailsForm,
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('UpdateCreditCardPopupShown');
  },
  destroyed() {
    PaymeInterface.teardown();
    this.reset();
  },
  computed: {
    ...mapState('subscription', ['tokenizationError', 'loadingToken', 'updateCompletedSuccessfully']),
    resultMessage() {
      return this.tokenizationError ? 'לא הצלחנו לחייב את הכרטיס' : 'פרטי הכרטיס החדש עודכנו בהצלחה';
    },
  },
  methods: {
    ...mapActions('subscription', ['updateCreditCard', 'reset']),
    ...mapActions('subscriptionState', ['optimisticChangeToSubscribed']),
    ...mapActions('creditCardDetails', ['fetch']),
    closeActionClicked() {
      Segment.trackUserInteraction('UpdateCreditCardPopupClosed');
      this.$emit('close');
    },
    getImageUrl() {
      const iconType = this.tokenizationError ? 'alert' : 'success';
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/icons/${iconType}-icon.svg`);
    },
    async updateCreditCardClicked() {
      Segment.trackUserInteraction('UpdateCreditCardPopup_UpdateClicked');
      await this.updateCreditCard();
      if (this.updateCompletedSuccessfully) {
        await this.fetch();
        this.optimisticChangeToSubscribed();
        setTimeout(() => {
          this.$emit('close');
        }, 2000);
      }
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .button-container {
    margin-top: 20px;

    .result-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 18px 16px;
      border-radius: 3px;
      background-color: rgba($riseup_gray_0, 0.4);

      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-family: GretaSans;
        font-size: 20px;
        color: $riseup_coral;
        margin-left: 20px;

        .icon {
          margin-left: 11px;
        }

        .message {
          font-size: 20px;
          font-family: GretaSans;

          &.error {
            color: $riseup_coral;
          }

          &.success {
            color: $riseup_green;
          }
        }
      }

      .cta {
        margin-top: 5px;
        font-family: SimplerPro;
        font-size: 16px;
        line-height: 1.5;
      }
    }
  }

</style>
